import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { AuthorizatedAdminGuard } from './guard/authorizated-admin.guard';
import { AuthorizatedAgentGuard } from './guard/authorizated-agent.guard';


const appRoutes: Routes = [

    {
      path: 'dashboard',
      loadChildren: './dashboard/dashboard.module#DashboardModule',
      canActivate: [AuthorizatedAgentGuard]
    },
    {
      path: 'auth',
      loadChildren: './auth/auth.module#AuthModule'
    },
    {
      path: 'admin',
      loadChildren: './admin/admin.module#AdminModule',
      canActivate: [AuthorizatedAdminGuard]
    },
    {
      path: '',
      redirectTo: 'auth',
      pathMatch: 'full'
    },
    {
      path: '**',
      redirectTo: 'auth',
      pathMatch: 'full'
    }

];


@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { //enableTracing: true,  // <- tests
        preloadingStrategy: PreloadAllModules,
          useHash: true }
    )
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/app-routing.module.ts